import { postForm } from '@/shared/api/client';

type GetNewAuthTokenResponse = {
  success?: number | boolean;
  token?: string;
  registration_step?: number | string | null;
};

/** Получить auth_token пользователя для перехода в ЛК (login-as). */
export const fetchUremontAuthToken = (userId: number | string) =>
  postForm<GetNewAuthTokenResponse>('/user/operator/get-new-auth-token/', {
    user_id: userId,
  });
